import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Standalone product quantity block. Stays in sync on variant change.
 */
class ProductQuantityComponent extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    const scope = this.closest('.shopify-section, featured-product-information') ?? document;

    scope.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /** @param {CustomEvent} event */
  #onVariantUpdate = (event) => {
    const productId = this.dataset.productId;

    if (event.detail?.data?.newProduct) {
      if (String(event.detail.data.newProduct.id) !== productId) return;
    } else if (event.detail?.data?.productId !== productId) {
      return;
    }

    const blockId = this.dataset.blockId;
    const selector = blockId
      ? `product-quantity-component[data-block-id="${blockId}"]`
      : 'product-quantity-component';
    const newElement = event.detail?.data?.html?.querySelector(selector);

    if (!(newElement instanceof HTMLElement) || newElement.isEqualNode(this)) return;

    const quantitySelector = this.querySelector('quantity-selector-component');
    const currentValue = quantitySelector?.getValue?.();

    morph(this, newElement);

    const updatedQuantitySelector = this.querySelector('quantity-selector-component');
    if (currentValue && updatedQuantitySelector?.setValue) {
      updatedQuantitySelector.setValue(currentValue);

      const quantityInput = updatedQuantitySelector.querySelector('input[ref="quantityInput"]');
      if (quantityInput instanceof HTMLInputElement && updatedQuantitySelector.updateConstraints) {
        updatedQuantitySelector.updateConstraints(
          quantityInput.min,
          quantityInput.max || null,
          quantityInput.step
        );
      }
    }
  };
}

if (!customElements.get('product-quantity-component')) {
  customElements.define('product-quantity-component', ProductQuantityComponent);
}
